import { observer } from "mobx-react-lite";
import useDefaultMapLayer from "../../hooks/useDefaultMapLayer";
import ILayerProps from "../../interfaces/IlayerProps";

export const countyFillLayerId = "County Fill";

function CountiesMapLayer({ visible }: ILayerProps) {
    useDefaultMapLayer(visible, () => [
        "County Lines",
        "County Text",
    ]);

    return (
        <></>
    );
}

export default observer(CountiesMapLayer);